import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_TASKS_REQUEST,
  fetchTasksSuccess,
  fetchTasksFailure,
  CREATE_TASK_REQUEST,
  createTaskSuccess,
  createTaskFailure,
  DELETE_TASK_REQUEST,
  deleteTaskSuccess,
  deleteTaskFailure,
  UPDATE_TASK_REQUEST,
  updateTaskSuccess,
  updateTaskFailure,
} from '../actions/taskActions';
import { getBaseUrl } from '../utils/getBaseUrl';

// Worker Saga: Fetch Tasks
function* fetchTasks() {
    try {
      // Log environment variable to verify it's loaded
    //   console.log('API URL:', process.env.REACT_APP_PORTURL);
  
      // Fetch data using the environment variable
      const response = yield call(axios.get, '/sampleTaskData.json');
      console.log('API Data:', response.data);
  
      // Dispatch success action
      yield put(fetchTasksSuccess(response.data));
    } catch (error) {
      console.log(error)
      // Dispatch failure action
      yield put(fetchTasksFailure(error.message));
    }
  }

  function* deleteTask(action) {
    try {
      yield call(axios.delete, `${getBaseUrl()}/task/${action.payload}`);
      yield put(deleteTaskSuccess(action.payload));
    } catch (error) {
      yield put(deleteTaskFailure(error.message));
    }
  }

// Worker Saga: Create Task
function* createTask(action) {
  try {
    const response = yield call(axios.post, `${getBaseUrl()}/task`, action.payload);
    yield put(createTaskSuccess(response.data));
  } catch (error) {
    yield put(createTaskFailure(error.message));
  }
}

function* updateTask(action) {
    console.log(action)
    try {
      const { taskId, updates } = action.payload;
      console.log("Task Payload",action.payload)
      const response = yield call(axios.patch, `${getBaseUrl()}/task/${taskId}`, updates);
      yield put(updateTaskSuccess(response.data));
    } catch (error) {
      yield put(updateTaskFailure(error.message));
    }
  }

// Watcher Saga: Watch for actions
function* taskSaga() {
  yield takeLatest(FETCH_TASKS_REQUEST, fetchTasks);
  yield takeLatest(CREATE_TASK_REQUEST, createTask);
  yield takeLatest(DELETE_TASK_REQUEST, deleteTask);
  yield takeLatest(UPDATE_TASK_REQUEST, updateTask);
}

export default taskSaga;
